export const getPriceLabel = (item, showShortLbl) => {
  let bidTit = "";
  let bidTitMob = "";
  let bidTxt = "";
  let BidAmt = "";
  let startBidTit = "";
  let startBidTxt = "";
  let startBidAmt = "";

  if (item?.listingType == "TRNL" && item?.listingPrice) {
    bidTit = "Listing Price";
    bidTxt = "";
    BidAmt = `$${item.listingPrice}`
  } else if (item?.startingBid) {
    bidTit = "Suggested Price";
    bidTxt = "";
    BidAmt = `$${item?.startingBid}`;
  }
  if ((item?.listingType == "TRNL" || item?.listingType == "AUCN") && item?.currentBid) {
    bidTit = showShortLbl ? "Current Offer" : "Current Highest Offer";
    bidTxt = "";
    BidAmt = `$${item?.currentBid}`;
  }
  if (item?.listingType == "AUCN" && item?.currentBid) {
    bidTit = "Current Highest Bid";
  }
  if (item?.listingType == "TRNL" && (item?.currentBid == "NA" || item?.currentBid == "" || item?.currentBid == "0" || item?.hasHnb == "Y")) {
    bidTit = "Listing Price";
    bidTxt = "";
    BidAmt = `$${item?.listingPrice}`;
  }
  if (item?.listingType == "AUCN" && (item?.currentBid == "0" || item?.currentBid == "NA" || item?.currentBid == "")) {
    bidTit = "Starting Bid";
    bidTxt = "";
    BidAmt = `$${item?.startingBid}`;
  }
  if (item?.tagName == "UnderContract") {
    bidTit = "";
    bidTxt = "Under Contract";
    BidAmt = "";
  }
  if (item?.tagName == "UnderReview") {
    bidTit = "";
    bidTxt = "Under Review";
    BidAmt = "";
  }
  if (item?.category == "FORECLOSURE" && item?.fcOnlineFlag != "Y") {
    bidTit = "";
    if (item?.estimatedBidPrice && item?.estimatedBidPrice != "" && item?.estimatedBidPrice!="0") {
      bidTit = "Estimated Opening Bid";
      bidTitMob = "Est. Opening Bid";
      bidTxt = "";
      BidAmt = `$${item?.estimatedBidPrice}`;
    } else {
      bidTit = "Estimated Opening Bid";
      bidTitMob = "Est. Opening Bid";
      bidTxt = "";
      BidAmt =  "TBD";
    }
  }
  if (item?.listingType == "AUCN" && item?.propertyStatus == "WFA") {
    bidTit = "Starting Bid";
  }
  if (item?.listingType == "AUCN" && item?.displayListPriceForAuction && item?.displayListPriceForAuction == "Y") {
    bidTit = "Listing Price";
    bidTxt = "";
    BidAmt = `$${item?.listingPrice}`;
  }
  if (item?.category == "NPL") {
    if (item?.listingPrice) {
      bidTit = "Listing Price";
      bidTxt = "";
      BidAmt = `$${item?.listingPrice}`;
    }
    if (item?.startingBid) {
      startBidTit = "Suggested Price";
      startBidTxt = "";
      startBidAmt = `$${item?.startingBid}`;
    }
  }
  if (item?.propertyStatus == "PACT") {
    bidTit = "Estimated Opening Bid";
  }
  if (item?.category === "NPL") {
    return {bidTit: startBidTit, bidTitMob: startBidTit, bidTxt: startBidTxt, BidAmt: startBidAmt?.replace('$$', '$')}
  } else {
    return {bidTit, bidTitMob, bidTxt, BidAmt: BidAmt?.replace('$$', '$')}
  }
};